/**
 * GTM dataLayer event tracking.
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

const BOOK_TABLE_SELECTOR = [
    '#sr-res-root',
    '#sr-res-root-mobile',
    '.btn-external .wp-block-button__link',
    '.mobile-menu-cta .wp-block-button__link',
].join(', ');

function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
}

export function initGtmEvents() {
    document.addEventListener('click', (event) => {
        if (!event.isTrusted) {
            return;
        }

        if (event.target.closest(BOOK_TABLE_SELECTOR)) {
            push({ event: 'book_table' });
        }

        const link = event.target.closest('a[href]');
        if (link && (link.getAttribute('href') || '').includes('#enquire')) {
            push({ event: 'enquire_now_click' });
        }
    });

    document.addEventListener('wpcf7mailsent', (event) => {
        if (!document.querySelector('.enquire-button-trigger')) {
            return;
        }

        push({
            event: 'enquire_now_submit',
            formId: event.detail.contactFormId,
        });
    }, false);
}
